import store from "@/store";
import i18n from "@/i18n";
import * as mt from "@/store/notification/mutation-types";
import {
  NotificationType,
  Notification,
  notification as notificationFactory
} from "@/store/notification/types";

export async function removeNotification(notification: Notification) {
  await store.dispatch(`notification/${mt.CLEAR_NOTIFICATION}`, notification);
}

async function addNotification(notification: Notification) {
  await store.dispatch(`notification/${mt.ADD_NOTIFICATION}`, notification);
}

function createNotification(
  type: NotificationType,
  title: string,
  message: string
) {
  return notificationFactory(type, title, message, 5000, true);
}

export function addSuccessNotification(message: string) {
  const noty = createNotification(
    "success",
    i18n.t("notifications.success") as string,
    message
  );
  addNotification(noty);
}

export function addWarnNotification(message: string) {
  const noty = createNotification(
    "warning",
    i18n.t("notifications.title.warning") as string,
    message
  );
  addNotification(noty);
}

export function addErrorNotification(message: string) {
  const noty = createNotification(
    "error",
    i18n.t("notifications.title.error") as string,
    message
  );
  addNotification(noty);
}
